import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

import { computed } from 'vue';
import { useMessageStore } from '@/store/message.store';

export default /*@__PURE__*/_defineComponent({
  __name: 'Message',
  setup(__props) {

const messageStore = useMessageStore();
const message = computed(() => messageStore.getMessage);
const status = computed(() => {
  return `messages--${messageStore.getStatus}`;
});

return (_ctx: any,_cache: any) => {
  return (message.value)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["messages h5 fw-normal mb-0", [status.value ? status.value : '']])
      }, _toDisplayString(_ctx.$t(`messages.${message.value}`)), 3))
    : _createCommentVNode("", true)
}
}

})